import React from 'react';

const SvgArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '28'}
    height={props.height || '42'}
    viewBox="0 0 28 42"
    fill="none"
    stroke="" // Agrega un borde negro
    strokeWidth="1" // Define el grosor del borde
    {...props}
  >
    <path
      d="M26.6297 23.2306L8.78523 41.075C7.55187 42.3083 5.55749 42.3083 4.33725 41.075L1.37192 38.1097C0.138558 36.8763 0.138558 34.8819 1.37192 33.6617L14.0205 21.0131L1.37192 8.36457C0.138558 7.13121 0.138558 5.13683 1.37192 3.91659L4.32413 0.925023C5.55749 -0.308341 7.55187 -0.308341 8.77211 0.925023L26.6165 18.7694C27.863 20.0028 27.863 21.9972 26.6297 23.2306Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrow;
